import { useEffect } from "react";

export function usePreloadImages(inputUrls: string[]) {
  const urls = [...new Set(inputUrls.filter(Boolean))].filter((url) =>
    /^https?:\/\/[^ "]+$/.test(url),
  );

  useEffect(() => {
    const links: HTMLLinkElement[] = [];

    for (const url of urls) {
      if (!url) continue;

      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = url;
      document.head.appendChild(link);
      links.push(link);
    }

    return () => {
      for (const link of links) {
        document.head.removeChild(link);
      }
    };
  }, [urls]);
}
